export default {
  breakpoints: {
    values: {
      xs: 0,
      mobile: 600,
      tablet: 768,
      tabletMedium: 800,
      tabletBig: 992,
      laptop: 1200,
      laptopMedium: 1240,
      laptopBig: 1330,
      desktopSmall: 1480,
      desktop: 1500,
    },
  },
}
